import * as React from 'react';
import { LabelsContainer } from '../LabelsContainer';
import { Features } from './Features';
import { useSelector } from 'react-redux';
import {
  getNewbuildingImagesByIdSelector,
  getNewbuildingNameByIdSelector,
  getNewbuildingUrlByIdSelector,
} from '../../selectors/newbuilding';
import { Image } from '../../components/Image';
import { CarouselBlock } from '../../components/CarouselBlock';
import { Carousel } from '../../components/Carousel';
import { IImageInfo } from '../../types/newbuilding';
import { ISlideProps } from '../../components/Carousel/Carousel';
import { Thumbnails } from '../../components/Thumbnails';
import { NoImage } from '../../components/NoImage';

interface ICarouselProps {
  newbuildingId: number;
  isLeadFactory?: boolean;
}

export const CarouselContainer = ({ newbuildingId, isLeadFactory }: ICarouselProps) => {
  const newbuildingImages = useSelector(getNewbuildingImagesByIdSelector(newbuildingId));
  const name = useSelector(getNewbuildingNameByIdSelector(newbuildingId));
  const url = useSelector(getNewbuildingUrlByIdSelector(newbuildingId));

  if (!newbuildingImages || !newbuildingImages.length) {
    return (
      <CarouselBlock
        features={<Features newbuildingId={newbuildingId} />}
        labels={<LabelsContainer offerId={newbuildingId} />}
      >
        <NoImage newbuildingId={newbuildingId} />
      </CarouselBlock>
    );
  }

  return (
    <CarouselBlock
      features={<Features newbuildingId={newbuildingId} />}
      labels={<LabelsContainer offerId={newbuildingId} />}
      thumbnails={isLeadFactory ? undefined : <Thumbnails images={newbuildingImages} />}
      url={url}
    >
      <Carousel
        slides={newbuildingImages.map(
          (img: IImageInfo, index: number) =>
            // eslint-disable-next-line react/display-name
            ({ visible }: ISlideProps) =>
              visible && (
                <Image alt={`${index + 1}-я Фотография ${name}`} src={img.thumbnailUrl} lazy objectFit="cover" />
              ),
        )}
        defaultSlideIndex={newbuildingImages.findIndex((img: IImageInfo) => img.isDefault)}
        hasThumbnails={!isLeadFactory && newbuildingImages.length > 3}
      />
    </CarouselBlock>
  );
};
